window.moment = require("dayjs")
window.dayjs = window.moment
window.humanize = require("humanize-string")
